export enum SearchTypes {
  collection,
  asset,
  approval,
}
